import React, { useState, useRef, useEffect, useCallback } from "react";

const AudioSessionTimer = (props) => {
  const Ref = useRef(null);

  // The state for our timer
  const [timer, setTimer] = useState("0:0:00");

  const getUpdatedTime = useCallback(() => {
    const total = Date.parse(new Date()) - Date.parse(props.startTime);
    const seconds = Math.floor((total / 1000) % 60);
    const minutes = Math.floor((total / 1000 / 60) % 60);
    const hours = Math.floor(total / 1000 / 60 / 60);
    return {
      total,
      hours,
      minutes,
      seconds,
    };
  }, [props.startTime]);

  const startTimer = useCallback(() => {
    const { total, hours, minutes, seconds } = getUpdatedTime();
    if (total >= 0) {
      setTimer(
        `${hours}:${minutes}:${seconds > 9 ? seconds : "0" + seconds}`
      );
    }
  }, [getUpdatedTime]);

  const clearTimer = useCallback(() => {
    setTimer("0:0:00");

    if (Ref.current) clearInterval(Ref.current); // Clear existing interval
    const id = setInterval(() => {
      startTimer();
    }, 1000);
    Ref.current = id;
  }, [startTimer]);

  const getDeadTime = () => {
    const deadline = new Date();
    deadline.setSeconds(deadline.getSeconds() + 10);
    return deadline;
  };

  useEffect(() => {
    clearTimer(getDeadTime());

    // Cleanup function to prevent memory leaks
    return () => {
      if (Ref.current) {
        clearInterval(Ref.current);
      }
    };
  }, [clearTimer]);

  return <div className="sessionTimer">{timer}</div>;
};

export default AudioSessionTimer;
